import React, { Component } from 'react';
import m from '@utils/strings';
export default class AppTitle extends Component {
  render() {
    const { classes } = this.props
    return (
      <div className={classes.divContainerInterno}>
        <div className={classes.divExterior}>
          <div className={classes.divInterior}>
            <div
              className={classes.autorizador}
              >
              {m.GERAL.TITULO_APLICACAO}
          </div>
          </div>
        </div>
      </div>
      
      
    )
  }
}
